import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import ServiceVehiclesViewModel from '../../ViewModels/ServiceVehicles';
import { TextField } from '@mui/material';

interface EditableTableCellProps {
    value: string | number | null;
    readOnly: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    type?: React.HTMLInputTypeAttribute;
}

const EditableTableCell: React.FC<EditableTableCellProps> = ({ value, readOnly, onChange, type }) => {
    const displayValue =
        type === 'number'
            ? value === -1 || value === null
                ? ''
                : value
            : value ?? '';

    return (
        <TableCell align="center">
            {readOnly ? (
                displayValue
            ) : (
                <TextField
                    value={displayValue}
                    onChange={onChange}
                    type={type}
                    size={'small'}
                    sx={{
                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                            WebkitAppearance: 'none',
                            margin: 0,
                        },
                        '& input[type=number]': {
                            MozAppearance: 'textfield',
                        },
                        px: -2,
                        mx: -2,
                        '& input': {
                            fontSize: '0.70rem',
                            padding: '1px 2px',
                            textAlign: 'center',
                        },
                        '& .MuiInputBase-root': {
                            height: '28px',
                        },
                    }}
                />
            )}
        </TableCell>
    );
};

interface SurveyTableRowProps {
    arrivals: number[];
    departures: number[];
    time: string;
    rowIndex: number;
    setValue: React.Dispatch<React.SetStateAction<ServiceVehiclesViewModel>>;
    survey: ServiceVehiclesViewModel;
    readOnly: boolean;
    hasMotc: boolean;
}
export default function ServiceVehiclesTableRow({ arrivals, departures, survey, time, rowIndex, setValue, readOnly, hasMotc }: SurveyTableRowProps) {

    const allArrivalValuesEmpty = arrivals.length === 0 || arrivals.every((value) => value === -1);
    const allDepartureValuesEmpty = departures.length === 0 || departures.every((value) => value === -1);
    const surveyOutOfPeriod = allArrivalValuesEmpty && allDepartureValuesEmpty;
    const arrivalTotal = surveyOutOfPeriod ? null : arrivals.reduce((sum, val) => (val !== -1 ? sum + val : sum), 0);
    const departureTotal = surveyOutOfPeriod ? null : departures.reduce((sum, val) => (val !== -1 ? sum + val : sum), 0);

    const handleOccChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        index: number,
        type: 'arrival' | 'departure'
    ) => {
        const updatedSurvey: ServiceVehiclesViewModel = { ...survey };
        const val = event.target.value;
        const num = val === '' ? -1 : parseInt(val, 10);

        if (type === 'arrival') {
            if (!updatedSurvey.arrivals) {
                updatedSurvey.arrivals = [];
            }

            const currentRowArr =
                arrivals ?? Array(5).fill(-1);

            const occArr = [...currentRowArr];
            occArr[index] = num;

            updatedSurvey.arrivals[rowIndex] = occArr.join(' ');

            //const allNegativeOne = occArr.slice(0, 7).every((val) => val === -1);
            //const weightedSum = occArr
            //    .slice(0, 7)
            //    .reduce(
            //        (sum, val, i) => (val !== -1 ? sum + val * (i + 1) : sum),
            //        0
            //    );

            //updatedSurvey.arrivals[rowIndex] = allNegativeOne ? '' : String(weightedSum);
        } else {
            if (!updatedSurvey.departures) {
                updatedSurvey.departures = [];
            }

            const currentRowArr =
                departures ?? Array(5).fill(-1);

            const occDeparture = [...currentRowArr];
            occDeparture[index] = num;

            updatedSurvey.departures[rowIndex] = occDeparture.join(' ');

            //const allNegativeOne = occDeparture.slice(0, 7).every((val) => val === -1);
            //const weightedSum = occDeparture
            //    .slice(0, 7)
            //    .reduce(
            //        (sum, val, i) => (val !== -1 ? sum + val * (i + 1) : sum),
            //        0
            //    );

            //updatedSurvey.departures[rowIndex] = allNegativeOne ? '' : String(weightedSum);
        }

        setValue(updatedSurvey);
    };

    return (
        <TableRow key={time}>
            <TableCell>{time}</TableCell>
            {surveyOutOfPeriod && readOnly ? (
                <TableCell colSpan={hasMotc ? 13 : 11} align="center">
                    Survey Did Not Take Place During This Time Period
                </TableCell>
            ) : (
                <>
                    {arrivals.map((value, index) => (
                        <EditableTableCell
                            value={value}
                            key={`Occarr-${index}`}
                            readOnly={readOnly}
                            type={'number'}
                            onChange={(e) => handleOccChange(e, index, 'arrival')}
                        />
                    ))}

                    {hasMotc && arrivals.length === 4 && <TableCell />}

                    <TableCell>{arrivalTotal ?? ''}</TableCell>

                    <TableCell />

                    {departures.map((value, index) => (
                        <EditableTableCell
                            value={value}
                            key={`Occdepp-${index}`}
                            readOnly={readOnly}
                            type={'number'}
                            onChange={(e) => handleOccChange(e, index, 'departure')}
                        />
                    ))}

                    {hasMotc && departures.length === 4 && <TableCell />}

                    <TableCell>{departureTotal ?? ''}</TableCell>
                </>
            )}
        </TableRow>
    );
}

